import { createFileRoute } from '@tanstack/react-router'
import { IncidentEdit } from '@/features/incidents/edit'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/$incidentId/edit'
)({
  component: IncidentEdit,
})

